import { useMemo } from 'react'
import { Link } from 'react-router'

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { CampaignSelector } from '@/components/features/CampaignSelector'
import { useCampaignSelection } from '@/entities/campaign'
import { useUserData } from '@/entities/user';
import { CampaignCard } from './ui/CampaignCard'

export function DialerPage() {
  const { role } = useUserData();
  const { campaigns, campaignsLoading, campaignId, setCampaignId } = useCampaignSelection()

  // Check if user is an org admin
  const isOrgAdmin = role === 'org:admin'

  // Find the selected campaign and check if dialer is active
  const selectedCampaign = useMemo(
    () => campaigns.find((c) => c.id === campaignId),
    [campaigns, campaignId]
  )

  const isDialerDisabled = useMemo(
    () => selectedCampaign && !selectedCampaign.dialer_is_active,
    [selectedCampaign]
  )

  const dialerContent = isDialerDisabled ? (
    <div className="space-y-4">
      <Alert variant="default" className="border-yellow-200 bg-yellow-50">
        <AlertTitle>Contact Support</AlertTitle>
        <AlertDescription>
          To enable the dialer feature for this campaign, please contact our support team. They
          will help you activate dialer functionality and configure the necessary settings.
        </AlertDescription>
      </Alert>
      {isOrgAdmin && selectedCampaign && (
        <div className="flex justify-center">
          <Button asChild variant="outline">
            <Link to={`/dialer/${selectedCampaign.id}/admin`}>Configure Dialer Settings</Link>
          </Button>
        </div>
      )}
    </div>
  ) : selectedCampaign ? (
    <CampaignCard
      campaignId={selectedCampaign.id}
      campaignName={selectedCampaign.name}
      isOrgAdmin={isOrgAdmin}
    />
  ) : null

  return (
    <div className="w-full h-full p-4 overflow-y-auto">
      {/* Header */}
      <div className="mb-4">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2">
          <div className="flex-shrink-0">
            <h1 className="text-heading font-bold text-gray-900 mb-1">Dialer</h1>
            <p className="text-detail text-gray-600">
              Manage your calling campaigns and dialer settings
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-2">
            <CampaignSelector
              campaigns={campaigns}
              selectedCampaignId={campaignId}
              onCampaignChange={setCampaignId}
              disabled={campaignsLoading}
              className="w-full sm:w-80 lg:w-96"
            />
          </div>
        </div>
      </div>

      {dialerContent}
    </div>
  )
}